import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class TokenStoreService {

    private static readonly TOKEN_PATH = 'quajoo.session.token';

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    set token(token: string) {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(TokenStoreService.TOKEN_PATH, token);
        }
    }

    get token(): string {
        console.log('get auth token form session store');
        if (isPlatformBrowser(this.platformId)) {
            return localStorage.getItem(TokenStoreService.TOKEN_PATH);
        } else {
            return null;
        }
    }
}
